import _classCallCheck from "/home/vsts/work/1/s/Rently.CustomerSite.Web/ClientApp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/Rently.CustomerSite.Web/ClientApp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var Helper =
/*#__PURE__*/
function () {
  function Helper() {
    _classCallCheck(this, Helper);
  }

  _createClass(Helper, null, [{
    key: "getDescendantProperty",
    value: function getDescendantProperty(object, path) {
      var list = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var firstSegment;
      var remaining;
      var dotIndex;
      var value;
      var index;
      var length;

      if (path) {
        dotIndex = path.indexOf('.');

        if (dotIndex === -1) {
          firstSegment = path;
        } else {
          firstSegment = path.slice(0, dotIndex);
          remaining = path.slice(dotIndex + 1);
        }

        value = object[firstSegment];

        if (value !== null && typeof value !== 'undefined') {
          if (!remaining && (typeof value === 'string' || typeof value === 'number')) {
            list.push(value);
          } else if (Object.prototype.toString.call(value) === '[object Array]') {
            for (index = 0, length = value.length; index < length; index++) {
              Helper.getDescendantProperty(value[index], remaining, list);
            }
          } else if (remaining) {
            Helper.getDescendantProperty(value, remaining, list);
          }
        }
      } else {
        list.push(object);
      }

      return list;
    }
  }]);

  return Helper;
}();

export { Helper as default };